<script setup>
import { Head } from '@inertiajs/vue3'

const props = defineProps({
	page: {
		type: Object,
		default: () => {},
	},
})

// Add SEO
const pageMeta = [
	{ tag: 'link', tagItem: 'rel', tagValue: 'canonical', contentItem: 'href', contentValue: `https://lekker.nl/${props.page.slug}` },
	{ tag: 'meta', tagItem: 'name', tagValue: 'title', contentItem: 'content', contentValue: props.page.meta_title },
	{ tag: 'meta', tagItem: 'name', tagValue: 'description', contentItem: 'content', contentValue: props.page.meta_description },
	{ tag: 'meta', tagItem: 'name', tagValue: 'keywords', contentItem: 'content', contentValue: props.page.keywords },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:title', contentItem: 'content', contentValue: props.page.meta_title },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:description', contentItem: 'content', contentValue: props.page.meta_description },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:type', contentItem: 'content', contentValue: `page` },
	{ tag: 'meta', tagItem: 'property', tagValue: 'og:url', contentItem: 'content', contentValue: `https://lekker.nl/${props.page.slug}` },
	{ tag: 'meta', tagItem: 'name', tagValue: 'twitter:card', contentItem: 'content', contentValue: 'summary' },
	{ tag: 'meta', tagItem: 'name', tagValue: 'twitter:site', contentItem: 'content', contentValue: '@lekker500' },
]
</script>

<template>
	<Head>
		<title>{{ page.title }}</title>
		<component
			:is="`${meta.tag}`"
			v-for="(meta, metaIndex) in pageMeta"
			:key="`pagemeta-${metaIndex}`"
			:[meta.tagItem]="meta.tagValue"
			:[meta.contentItem]="meta.contentValue"
		/>
	</Head>
	<main class="page-main py-3 py-md-5">
		<div class="container-xxl main-wrapper">
			<div class="row justify-content-center">
				<div class="col-lg-8">
					<h1 class="h2 ff-serif mb-lg-4">{{ page.title }}</h1>
					<div v-html-raw="page.content" />
				</div>
			</div>
		</div>
	</main>
</template>
